const NORMAL = { code: "NOR", description: "Normal" };
const FLAG = { code: "FLG", description: "Flag" };
const INCOMPLETE = { code: "INC", description: "Incomplete" };

export default {
    NORMAL,
    FLAG,
    INCOMPLETE
};


// WEBPACK FOOTER //
// ./src/areas/shared/consts/CommentType.js